import { axiosInstance } from '@/utils/api'
import { EOperatorType } from '@/utils/enums'

interface ISerialParams {
  code: string
  barcodeId: string
  operatorType: EOperatorType
  isEdit: boolean
}

interface ISerialLastHistoryDetailParams {
  code: string
}

interface ISerialLastHistoryDetailResponse {
  id: number
  code: string
  limitAmount: number
  initAmount: number
  currentAmount: number
  productId: number
  itemName: string
  itemCode: string
  unit: string
  conversionUnit: string
  trollyIndex: number
  trollyNumber: number
}

export interface ISerialHistoryFullDataItem {
  orderNumber: string
  manufacturingPlanId: number
  productId: number
  itemCode: string
  barcodeId: string
  operatorType: EOperatorType
  amount: number
  scannedDateTime: string
}

export interface ISerialFullDataResponse {
  id: number
  code: string
  serialHistories: ISerialHistoryFullDataItem[]
}

export async function checkSerialCanUse(params: ISerialParams) {
  const response = await axiosInstance.get('/serial/serial-can-use', { params: { ...params } })
  return response?.data
}

export async function checkSerialLastHistoryDetail(params: ISerialLastHistoryDetailParams) {
  const response = await axiosInstance.get('/serial/detail', { params: { ...params } })
  return response?.data as ISerialLastHistoryDetailResponse
}

export async function getSerialHistories(serialCode: string) {
  const response = await axiosInstance.get('/serial/serial-histories', { params: { serialCode } })
  return response?.data as ISerialFullDataResponse
}
